export interface IModelModelResponse {
  id: string;
  name: string;
  value: string;
}

export class ModelModel {
  id: string;
  name: string;
  value: string;

  // additional properties can be added here
  label?: string;

  constructor(props = {} as IModelModelResponse) {
    this.id = props.id;
    this.name = props.name;

    this.value = props.value;
  }
}